'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialLinkedinBlackAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2 4.66893C2 4.02542 2.22523 3.49453 2.67568 3.07627C3.12612 2.65798 3.71172 2.44885 4.43243 2.44885C5.14029 2.44885 5.71299 2.65476 6.15058 3.06661C6.60102 3.49132 6.82626 4.04472 6.82626 4.72684C6.82626 5.34461 6.60747 5.85939 6.16988 6.27125C5.71944 6.69596 5.12741 6.90831 4.39382 6.90831H4.37452C3.66666 6.90831 3.09396 6.69596 2.65637 6.27125C2.21878 5.84654 2 5.31242 2 4.66893ZM2.25097 21.5608V8.66507H6.53668V21.5608H2.25097ZM8.9112 21.5608H13.1969V14.3601C13.1969 13.9096 13.2484 13.5621 13.3514 13.3176C13.5315 12.88 13.805 12.51 14.1718 12.2075C14.5386 11.9051 14.9987 11.7539 15.5521 11.7539C16.9936 11.7539 17.7143 12.7256 17.7143 14.6689V21.5608H22V14.167C22 12.2622 21.5496 10.8176 20.6486 9.83302C19.7477 8.84847 18.5573 8.35619 17.0772 8.35619C15.417 8.35619 14.1236 9.07047 13.1969 10.499V10.5377H13.1776L13.1969 10.499V8.66507H8.9112C8.93693 9.0769 8.94981 10.3575 8.94981 12.5068C8.94981 14.6561 8.93693 17.6741 8.9112 21.5608Z",
        fill: "#101010"
      }
    )
  }
);
const VpSocialLinkedinBlackAsset = forwardRef(SocialLinkedinBlackAsset);

export { VpSocialLinkedinBlackAsset as default };
